// removed by extract-text-webpack-plugin
module.exports = {"outer":"jCPR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InfoSidebar/InfoSidebar.scss
// module id = Kf9N
// module chunks = 0